import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import USPBar from "../components/USPBar";
import Services from "../components/Services";
import About from "../components/About";
import Process from "../components/Process";
import Projects from "../components/Projects";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import CTA from "../components/CTA";

const Home = () => {
  return (
    <div className="bg-white">
      <Header />
      <main>
        <Hero />
        <USPBar />
        <Services />
        <About />
        <Process />
        <Projects />
        <Testimonials />
        <CTA />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
